"use strict";

import Dom from "common/Dom";
import * as handlers from "components/International/handlers.js";
var overlayActionEnd = function overlayActionEnd(action, resolve) {
  $(Dom.overlay).one("transitionend", function () {
    if (action === "show" && $(Dom.overlay).is(".is-active")) {
      resolve();
    } else if (action === "hide" && !$(Dom.overlay).is(".is-active")) {
      resolve();
    }
  });
};
export const showOverlay = function showOverlay() {
  return new Promise(function (resolve) {
    overlayActionEnd("show", resolve);
    $(Dom.overlay).addClass("is-active");
  });
};
export const hideOverlay = function hideOverlay() {
  return new Promise(function (resolve) {
    overlayActionEnd("hide", resolve);
    $(Dom.overlay).removeClass("is-active");
    if ($(Dom.intModal).length > 0) {
      handlers.closeProductModal();
    }
    if ($("[data-modal].is-active").length > 0) {
      $("[data-modal].is-active").removeClass("is-active");
    }
  });
};
